<template>
  <v-card flat color="transparent">
    <v-card-text class="py-0">
      <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
        <v-col cols="12" class="pa-0 b-B">
          <v-toolbar flat color="transparent" height="40">
            <v-toolbar-title class="text-left subheading">
              <span class="title">学校</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark rounded depressed small color="error" @click.native="onAdd()">
              <span class="text-none">追加</span>
            </v-btn>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-sheet class="overflow-y-auto" :style="contentsHeight">
        <v-row class="ma-0 pa-0" align="center">
          <v-col cols="1" class="pa-0" align="center"></v-col>
          <v-col cols="11" class="pa-0">
            <v-row class="ma-0 py-0" align="center">
              <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                <v-row align="center" justify="center" style="height:48px;">
                  <template v-for="(header, index) in headers">
                    <v-col :cols="header.width"  :align="header.align" class="pa-0" :key="header.key">
                      <template v-if="header.valid">
                        <v-sheet class="pa-0 customHeader" color="transparent">
                          <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                          <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                        </v-sheet>
                      </template>
                      <template v-else>
                        <span>{{ header.title }}</span>
                      </template>
                    </v-col>
                  </template>
                  <v-col class="pa-0" align="center">
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0" align="center">
                <div class='overflow-y-auto'>
                  <RecycleScroller
                    class="scroller"
                    :items="filterItems"
                    :item-size="44"
                    key-field="key"
                  >
                    <template v-slot="{ item }">
                      <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                        <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;" @click.stop="onSelect(item)">
                          <template v-for="(header) in headers">
                            <v-col :cols="header.width" class="pa-0" align="start" :key="header.key">
                              <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                            </v-col>
                          </template>
                          <v-col cols="1" class="pa-0" align="center">
                            <v-btn class="pa-0 ma-0" icon @click.stop.prevent="onDeleteDialog(item)">
                              <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-sheet>
                    </template>
                  </RecycleScroller>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card-text>

    <div>
      <v-dialog v-model="addDialog"
        persistent
        max-width="400"
        >
        <template-scholae-dialog
          v-if="addDialog"
          @dismissed="onDismissed"
          :dialog='addDialog'
          :item="item"
          :type="type"
        >
        </template-scholae-dialog>
      </v-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if="deleteDialog"
        @dismissed="onDismissed"
        title='削除'
        :message="deleteItem.name + ' を削除します。よろしいですか?'"
        :dialog='deleteDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-card>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TemplateScholaeDialog from './TemplateScholaeDialog.vue'
Vue.component('template-scholae-dialog', TemplateScholaeDialog)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scholae: 'scholae/scholae',
      students: 'students/students',
      windowSize: 'shared/windowSize'
    }),
    filterItems () {
      var temp = []
      for (var i in this.scholae) {
        if (this.scholae[i].schools[this.mySchool.key]) {
          temp.push(JSON.parse(JSON.stringify(this.scholae[i])))
        }
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    mySchool () {
      if (this.school) {
        return JSON.parse(JSON.stringify(this.school))
      } else {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            var index = this.schools.findIndex(s => s.key === keys[i])
            if (index !== -1) {
              return JSON.parse(JSON.stringify(this.schools[index]))
            }
          }
        }
      }
      return null
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  data () {
    return {
      headers: [
        { valid: true, over: false, value: 2, title: '名称', key: 'name', width: '6', align: 'start' },
        { valid: true, over: false, value: 0, title: '住所', key: 'address', width: '5', align: 'start' }
      ],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      addDialog: false,
      deleteDialog: false,
      deleteItem: null,
      loading: false,
      // school: null,
      item: null
      // type: 'edit'
    }
  },
  props: [ 'type', 'school' ],
  methods: {
    onClose () {
      this.$emit('dismissed')
    },
    onAdd () {
      this.item = JSON.parse(JSON.stringify(this.$store.getters['scholae/initial']))
      var v = {}
      v[this.mySchool.key] = true
      this.item.schools = v
      this.addDialog = true
    },
    onSelect (item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.file = null
      this.addDialog = true
    },
    onDeleteDialog (item) {
      this.deleteItem = item
      this.deleteDialog = true
    },
    onDelete () {
      var vm = this
      this.loading = true
      this.$store.dispatch('scholae/delete', JSON.parse(JSON.stringify(this.deleteItem.key))).then(() => {
        vm.loading = false
        vm.deleteDialog = false
        vm.item = null
      })
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onDismissed: function (value) {
      if (this.deleteDialog) {
        this.deleteDialog = false
        if (value) {
          this.onDelete()
        }
        return
      }
      this.addDialog = false
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}
 .overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  line-height: 48px;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}
</style>
